export const INITIAL_STATE = {
    tags: [],
    articleSubmittedErrors: null,
    articleSubmittedIsLoading: false,
    title: '',
    description: '',
    body:'',
    tagList: []
}
